import type { SavedViewScope as SharedSavedViewScope } from "@/constants/saved-view-scopes"

import type { SavedView as SharedSavedView } from "@/components/saved-views/types"

import type { ConversationsMetadataFilter, MetricValueFilter } from "../types"

export type SavedViewScope = SharedSavedViewScope

export interface MetricFilter {
  metricName: string
  operator: ">" | "<" | "=" | ">=" | "<=" | "!=" | "exists" | "range"
  value: number | string | null
  rangeMax?: number
  valueType?: "number" | "string"
}

export interface SavedViewFilters {
  metricFilters?: MetricFilter[]
  metadataFilters?: ConversationsMetadataFilter[]
  metricValueFilters?: MetricValueFilter[]
  startDate?: string
  endDate?: string
  metricIds?: string[]
  agentIds?: string[]
  tagFilters?: string[]
  projectIds?: string[]
}

export interface SavedViewDisplay {
  visibleColumns?: string[]
  sortColumn?: string
  sortDirection?: string
  timestampMode?: string
  metadataColumns?: Array<{
    id: string
    fieldPath: string
    displayName: string
    isVisible: boolean
  }>
}

export interface SavedViewMetadata {
  createdBy?: string
  createdAt?: string
  updatedAt?: string
  isShared?: boolean
  isDefault?: boolean
  description?: string
  /**
   * Scope discriminator stamped by the server on create/update. Filters
   * queries between uploaded conversations and runs. Clients never write this directly.
   */
  scope?: SavedViewScope
}

export interface SavedViewConfig {
  filters?: SavedViewFilters
  display?: SavedViewDisplay
  metadata?: SavedViewMetadata
  isDefault?: boolean
}

// Narrowed alias over the shared generic; existing uploaded conversation code that
// imports `SavedView` from this file gets the same shape as before.
export type SavedView = SharedSavedView<SavedViewConfig>

// Constants
export const AUTO_SAVE_DELAY = 1000 // milliseconds
